import { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * A single-page app keeps the scroll position across route changes, so a
 * link clicked at the bottom of one page lands at the bottom of the next.
 * Reset to the top on every pushed or replaced navigation; leave POP alone so
 * the browser's own Back/Forward restoration still works. Hash-only changes
 * (the Health Check panel) do not move the page.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();
  useLayoutEffect(() => {
    if (navigationType === 'POP') return;
    window.scrollTo(0, 0);
  }, [pathname, navigationType]);
  return null;
}
